export default {
  admin: {
    title: 'Администратор',
    value: 'admin',
  },
  user: {
    title: 'Пользователь',
    value: 'user',
  },
  integration: {
    title: 'Пользователь 1C',
    value: 'integration',
  },
}